import { ArrowRight } from '@berlitz/icons'
import { Consumer } from '@layouts/PageLayout/Context'
import Router from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Back, Body } from './style'

/* TODO: Add button with right icon to max
 */
interface IBackButton {
  onClick?: Function
  back?: string
}

const BackButton: React.FC<IBackButton> = ({ onClick, back }) => (
  <Body fluid>
    <Row>
      <Col>
        <Consumer>
          {({ isFormDirty, displayUnsavedModal }) => (
            <Back
              onClick={() => {
                if (isFormDirty && !onClick && !back) {
                  return displayUnsavedModal('back')
                }
                if (back) {
                  return Router.push(back)
                }
                if (onClick) {
                  return onClick()
                }
                return Router.back()
              }}
            >
              <ArrowRight />
              <FormattedMessage id="back" defaultMessage="Back" />
            </Back>
          )}
        </Consumer>
      </Col>
    </Row>
  </Body>
)

export default BackButton
